var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.icon,{tag:"component",staticClass:"hero-icon",attrs:{"width":_vm.size,"height":_vm.size,"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }